document.addEventListener("DOMContentLoaded", function () {
  if (localStorage.getItem("type") == null) {
    var type = document.querySelector("#category-view-type").value;
    var cols = document.querySelector("#category-grid-cols").value;

    if (type == "list") {
      category_view.initView(type, cols, "btn-list");
      category_view.customList();
    }

    if (type == "grid") {
      category_view.initView(type, cols, "btn-grid-" + cols);
      category_view.customGrid();
    }
  } else {
    var type = localStorage.getItem("type");
    var cols = localStorage.getItem("cols");
    var element = localStorage.getItem("element");

    category_view.initView(type, cols, element);
  }
});

var category_view = {
  initView: function (type, cols, element) {
    this.changeView(type, cols, element);
  },
  changeView: function (type, cols, element) {
    var productItems = document.querySelectorAll("#content .product-item");
    if (type == "grid") {
      var column = parseInt(cols);
      if (column == 2) {
        productItems.forEach(function (item) {
          item.className = "product-layout product-grid grid-style col-lg-6 col-md-6 col-sm-6 col-xs-6 product-item ";
          if(mt.enable_animation == "true"){
            item.className += " scroll-trigger animate--slide-in";
          }
          item.parentElement.classList.add("row-cols-2","row-cols-md-3");
        });
      }
      if (column == 3) {
        productItems.forEach(function (item) {
          item.className = "product-layout product-grid grid-style col-lg-4 col-md-4 col-sm-4 col-xs-4 product-item";
          if(mt.enable_animation == "true"){
            item.className += " scroll-trigger animate--slide-in";
          }
          item.parentElement.classList.remove("row-cols-2","row-cols-md-3");
        });
      }
      if (column == 4) {
        productItems.forEach(function (item) {
          item.className = "product-layout product-grid grid-style col-lg-3 col-md-3 col-sm-3 col-xs-6 product-item";
          if(mt.enable_animation == "true"){
            item.className += " scroll-trigger animate--slide-in";
          }
          item.parentElement.classList.remove("row-cols-2","row-cols-md-3");
        });
      }
      if (column == 5) {
        productItems.forEach(function (item) {
          item.className = "product-layout product-grid grid-style col-lg-divide-5 col-md-divide-5 col-sm-6 col-xs-6 product-item";
          if(mt.enable_animation == "true"){
            item.className += " scroll-trigger animate--slide-in";
          }
          item.parentElement.classList.remove("row-cols-2","row-cols-md-3");
        });
      }

      this.customGrid();
    }

    if (type == "list") {
      productItems.forEach(function (item) {
        item.className = "product-layout product-list col-xs-12 product-item";
        if(mt.enable_animation == "true"){
          item.className += " scroll-trigger animate--slide-in";
        }
        item.parentElement.classList.remove("row-cols-2","row-cols-md-3");
      });

      this.customList();
    }

    var btnCustomViews = document.querySelectorAll(".btn-custom-view");
    btnCustomViews.forEach(function (btn) {
      btn.classList.remove("active");
    });
    document.querySelector("." + element) && document.querySelector("." + element).classList.add("active");

    localStorage.setItem("type", type);
    localStorage.setItem("cols", cols);
    localStorage.setItem("element", element);
    if (mt.grid_auto_resize != "false") {
      mt.resizeCollGrid();
    }
  },
  customList: function () {
    var items = document.querySelectorAll(".product-item .item");
    items.forEach(function (item) {
      var caption = item.querySelector(".caption");
      var actionLinks = item.querySelector(".action-links");
      caption.appendChild(actionLinks);
      //item.querySelector(".action-links").appendTo(caption);
    });
  },
  customGrid: function () {
    var items = document.querySelectorAll(".product-item .item");
    items.forEach(function (item) {
      var imagesContainer = item.querySelector(".images-container");
      var actionLinks = item.querySelector(".action-links");
      imagesContainer.appendChild(actionLinks);
      //item.querySelector(".action-links").appendTo(imagesContainer);
    });
  },
};
